import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "roadsideAssistance"
const RoadsideAssistanceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M1.5 15.618V13.68q0-.411.278-.69a.94.94 0 0 1 .69-.278h6.97L3.437 7.97v1.84a.94.94 0 0 1-.278.69.94.94 0 0 1-.69.278.94.94 0 0 1-.69-.278.94.94 0 0 1-.278-.69V6.08q0-.555.472-.835a.91.91 0 0 1 .956-.012l10.19 5.591V4.968q0-.411.278-.69a.94.94 0 0 1 .69-.278h2.977q.435 0 .823.182.387.18.653.52l3.8 4.574q.217.267.339.581.12.315.12.654v5.107a.94.94 0 0 1-.278.69.94.94 0 0 1-.69.278h-1.452a2.8 2.8 0 0 1-.847 2.057 2.8 2.8 0 0 1-2.057.847 2.8 2.8 0 0 1-2.057-.847 2.8 2.8 0 0 1-.847-2.057H9.245a2.8 2.8 0 0 1-.847 2.057 2.8 2.8 0 0 1-2.057.847 2.8 2.8 0 0 1-2.058-.847 2.8 2.8 0 0 1-.847-2.057h-.968a.94.94 0 0 1-.69-.279.94.94 0 0 1-.278-.69m4.84 2.42q.63 0 1.041-.412.412-.41.412-1.04t-.412-1.041q-.41-.411-1.04-.412-.63 0-1.041.412-.412.411-.412 1.04 0 .63.412 1.041.411.412 1.04.412m11.134 0q.63 0 1.04-.412.412-.41.412-1.04t-.411-1.041q-.411-.411-1.04-.412-.63 0-1.042.412-.411.411-.411 1.04 0 .63.411 1.041.412.412 1.041.412m-2.42-8.23h5.228l-3.244-3.872h-1.984z" />
    </svg>
  )
}
export default RoadsideAssistanceIcon
